<template>
  <div :class="[`fw-filterpel-filters-inner`]">
    <FilterEntry
      v-for="filter in filterData"
      :key="filter.key"
      v-model="filterValues[filter.key]"
      :filter="filter"
      :filter-props="filter.props"
      @apply="applyFilter"
    />
  </div>
  <div :class="[`fw-filterpel-filters-actions`]">
    <PrimeVueButton class="action-clearall" @click="clearFilter">
      <span>{{ languageStrings.reset[languageStore.language] }}</span>
    </PrimeVueButton>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, useHost, getCurrentInstance } from "vue";

import { default as PrimeVueButton } from 'primevue/button';

import FilterEntry from "@components/FilterEntry.vue";

import useStateStore from "@stores/state";
import useEntriesStore from "@/stores/entries";
import useLanguageStore from "@/stores/language";

// define stores
const stateStore = useStateStore();
const entriesStore = useEntriesStore();
const languageStore = useLanguageStore();

// define props
const props = defineProps<{
  elemId: string,
  filters: string;
  activeFilters: string;
  language?: string;
}>();

// set language
if (props.language) {
  languageStore.setLanguage(props.language);
}

// define language strings
const languageStrings: ILanguageStrings = {
  reset: {
    de: "Alle Filter zurücksetzen",
    en: "Reset all filters",
  }
};

// prepare filters
const filterData = ref<IFilter[]>([]);
const filterValues = ref<Record<string, unknown>>({});

// methods
const applyFilter = () => {
  entriesStore.applyFilters(props.elemId, filterValues.value);
};
const clearFilter = () => {
  filterValues.value = {};
  entriesStore.applyFilters(props.elemId, filterValues.value);
};

// livecycle - mounted
onMounted(() => {
  // init instance on state
  const hostNode = useHost() ?? getCurrentInstance()?.proxy?.$el;
  stateStore.addInstance(props.elemId, "filters", hostNode);

  // set filters
  const parsedFilterData = JSON.parse(props.filters);
  const parsedActiveFilters = JSON.parse(props.activeFilters);
  filterData.value = parsedFilterData;
  filterValues.value = { ...parsedActiveFilters };
});

</script>
